module.exports = {
  UPLOAD: 'UPLOAD'
};
